// sort-imports-ignore
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';

import { LanguageProvider, QueryProvider } from '@/contexts';
import { useKeyboardAwareInput } from '@/hooks';
import {
  Android,
  Appointment,
  Club,
  Group,
  Help,
  Invalid,
  Ios,
  LandingPage,
  Maintenance,
  Schedule,
  Share,
  DeleteAccount,
  PrivacyPolicy,
  TermsOfService
} from '@/pages';
import { ROUTES } from '@/utils/routes';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';

/* Theme variables */
import '@/theme/variables.css';

setupIonicReact({
  mode: 'ios'
});

const App: React.FC = () => {
  useKeyboardAwareInput();

  return (
    <IonApp>
      <IonReactRouter>
        <LanguageProvider>
          <QueryProvider>
            <IonRouterOutlet animated={false}>
              {/** Landing Page **/}
              <Route exact path={ROUTES.ROOT}>
                <LandingPage />
              </Route>
              {/** Invalid Page **/}
              <Route exact path={ROUTES.INVALID}>
                <Invalid />
              </Route>
              {/** Maintenance Page **/}
              <Route exact path={ROUTES.MAINTENANCE}>
                <Maintenance />
              </Route>
              {/** Privacy Policy **/}
              <Route exact path={ROUTES.PRIVACY_POLICY}>
                <PrivacyPolicy />
              </Route>
              {/** Terms of Service **/}
              <Route exact path={ROUTES.TERMS_OF_SERVICE}>
                <TermsOfService />
              </Route>
              {/** Schedule Page **/}
              <Route exact path={ROUTES.SCHEDULE}>
                <Schedule />
              </Route>
              {/** Share Page **/}
              <Route exact path={ROUTES.SHARE}>
                <Share />
              </Route>
              {/** Appointment Page **/}
              <Route exact path={ROUTES.APPOINTMENT}>
                <Appointment />
              </Route>
              {/** Help Page **/}
              <Route exact path={ROUTES.HELP}>
                <Help />
              </Route>
              {/** Delete Account Page **/}
              <Route exact path={ROUTES.DELETE_ACCOUNT}>
                <DeleteAccount />
              </Route>
              {/** Download Link: Android **/}
              <Route exact path={ROUTES.ANDROID}>
                <Android />
              </Route>
              {/** Download Link: iOS **/}
              <Route exact path={ROUTES.IOS}>
                <Ios />
              </Route>
              {/** Club Link **/}
              <Route exact path={ROUTES.CLUB}>
                <Club />
              </Route>
              {/** Group Page **/}
              <Route exact path={ROUTES.GROUP}>
                <Group />
              </Route>
              {/** Share Page (Direct) **/}
              <Route exact path={ROUTES.SHARE_DIRECT}>
                <Share />
              </Route>
              {/** Fallback Route **/}
              <Route>
                <Redirect to={ROUTES.INVALID} />
              </Route>
            </IonRouterOutlet>
          </QueryProvider>
        </LanguageProvider>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
